import axios from '../axios';
const END_POINT = '/configs';

const getConfigs = () => axios.get(`${END_POINT}/`);
const getConfig = (id) => axios.get(`${END_POINT}/${id}`);
const updateConfig = (id, payload) => axios.patch(`${END_POINT}/${id}`, payload);

export {
    getConfigs,
    getConfig,
    updateConfig,
}